import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=fa8db368&"
var script = {}
import style0 from "./MyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports